export const getLaboratory = (laboratoryId) => ({ laboratories }) =>
laboratories.laboratoriesList.find(({ id }) => id === laboratoryId);